





















































import Vue from 'vue';
import { mapActions } from 'vuex';
import SpotifyApi from 'spotify-web-api-node';

import api from '@/api';
import { REQUEST_TYPE } from '@/config';
import ListItem from '@/components/ui/list/list-item.vue';
import { BUTTON_COLORS } from '../../config';
import MenuNavigation from '../shared/menu-navigation.vue';

export default Vue.extend({
  name: 'Albums',

  components: {
    MenuNavigation,
    ListItem,
  },

  data: () => ({
    buttonColors: BUTTON_COLORS,

    query: '',

    albums: [] as SpotifyApi.AlbumObjectSimplified[],

    chosen: [] as SpotifyApi.AlbumObjectSimplified[],
  }),

  methods: {
    ...mapActions('data', [
      'changeSettingsAlbums',
      'collectData',
    ]),

    back() {
      this.changeSettingsAlbums([]);
      this.$emit('select', REQUEST_TYPE.NONE);
    },

    async search() {
      if (this.query === '') {
        return;
      }
      const response = await api.spotify.album.search(this.query);

      this.albums = (response.body.albums as SpotifyApi.PagingObject<SpotifyApi.AlbumObjectSimplified>).items;
    },

    select(index: number) {
      const album = this.albums[index];

      if (this.chosen.includes(album)) {
        this.chosen = this.chosen.filter((item) => item.id !== album.id);
      } else {
        this.chosen.push(album);
        this.albums = this.albums.filter((item) => item.id !== album.id);
      }
    },

    deselect(index: number) {
      const album = this.chosen[index];

      if (this.chosen.includes(album)) {
        this.chosen = this.chosen.filter((item) => item.id !== album.id);
      }
    },

    map() {
      this.changeSettingsAlbums(this.chosen);

      this.collectData();
      this.$router.push('/exploring');
    },
  },
});
